<template>
  <article class="blog-card card-915">
    <div class="card-image">
      <img class="blog-img-card w-100" :src="image" :alt="alt"/>
    </div>
    <div class="blog-card-header">
      <slot name="p-1">
        When life gives you oranges
      </slot>
    </div>
    <div class="blog-card-footer">
      <div class="card-meta card-meta--date">
        <slot name="p-2">
          <svg class="mx-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" display="block"
               id="Calendar">
            <rect x="2" y="4" width="20" height="18" rx="4"/>
            <path d="M8 2v4"/>
            <path d="M16 2v4"/>
            <path d="M2 10h20"/>
          </svg>
          Jul 26, 2019
        </slot>
      </div>
    </div>
  </article>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card915",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
img {
  max-width: 100%;
  display: block;
}


.blog-card {
  background-color: #FFF;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 20px 50px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  overflow: hidden;
  padding: 1.25rem;
  position: relative;
  transition: 0.15s ease-in;
  width: 100%;
  max-width: 400px;
  height: 460px;
}

.blog-card:hover, .blog-card:focus-within {
  box-shadow: 0 0 0 2px #16C79A, 0 10px 60px 0 rgba(0, 0, 0, 0.1);
  transform: translatey(-5px);
}

.card-image {
  border-radius: 10px;
  overflow: hidden;
}

.blog-card-header {
  margin-top: 1.5rem;
}

.blog-card-header :deep(*) {
  line-height: 1.25;
  text-decoration: none;
  color: inherit;
  will-change: transform;
}

.blog-card-header :deep(*:after) {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}


.icon-button svg {
  width: 1em;
  height: 1em;
}

.blog-card-footer {
  margin-top: 1.25rem;
  border-top: 1px solid #ddd;
  padding-top: 1.25rem;
}

.card-meta {
  color: #787878;
}

.card-meta svg {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-right: 0.25em;
}

.blog-img-card {

  object-fit: cover;
  aspect-ratio: 3/2;
}


</style>